import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '../pages/login';
import { RegisterPage } from '../pages/register';
import { Layout } from '../fragments/layout';
import { Router } from './router';

export const RouterSwitcher = () => {
  const token = localStorage.getItem('access-token');

  return token ? (
    <Layout>
      <Router />
    </Layout>
  ) : (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};
